/**
 * Input Config Stores - Coordinator-owned state for input configuration
 *
 * These stores replace direct reads from the legacy shared.ts stores
 * (gamepadState, hostRuleState, pauseInputState). Legacy stores are bridged
 * into these via listeners in init.ts (strangler fig pattern).
 *
 * Managers read exclusively from these coordinator-owned stores.
 */

import type { StateStore } from '@playcastdotio/CoreTypes';
import { makeStateStore } from '@playcastdotio/StateStore';

export type GamepadConfigState = {
  autoAssign: boolean;
  maxAssignments: number;
  shareFlags: boolean[];
};

export type InputRulesState = {
  enableGamepadFiltering: boolean;
};

export type PauseInputState = {
  paused: boolean;
  players: Record<string, { paused: boolean }>;
};

export type InputConfigStores = {
  gamepadConfig: StateStore<GamepadConfigState>;
  inputRules: StateStore<InputRulesState>;
  pauseInput: StateStore<PauseInputState>;
};

export function createInputConfigStores(): InputConfigStores {
  return {
    gamepadConfig: makeStateStore<GamepadConfigState>({
      autoAssign: true,
      maxAssignments: 4,
      shareFlags: [false, false, false, false],
    }),
    inputRules: makeStateStore<InputRulesState>({
      enableGamepadFiltering: false,
    }),
    pauseInput: makeStateStore<PauseInputState>({
      paused: false,
      players: {},
    }),
  };
}
